<template>
  <div>
    <b-form-input
      v-model="location"
      type="text"
      :size="nav ? 'sm' : ''"
      :state="isValidState"
      :class="{ 'full-width': mobile }"
      @keydown.native="keyDownAutoComplete"
      @blur.native="blurAutoComplete"
      autocomplete="new-password"
    ></b-form-input>
    <b-list-group v-if="showLocations" class="autocomplete">
      <b-list-group-item
        :class="{ 'list-group-item-nav': nav && !mobile, 'list-group-item-nav-mobile' : nav && mobile }"
        v-for="chooseLocation in locations"
        :key="chooseLocation.id"
        @click="setLocationAndCoordinates(chooseLocation)"
      >{{ chooseLocation.name }}</b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { defaultMixin } from '../mixin/default'

import { geocodeService } from '../services/geocode.service'

import _ from 'lodash'

export default {
  name: 'locationpicker',
  props: {
    id: {
      type: String,
      required: false,
      default: this.uuid
    },
    nav: {
      type: Boolean,
      required: false,
      default: false
    },
    mobile: {
      type: Boolean,
      required: false,
      default: false
    },
    city: {
      type: String,
      required: false,
      default: null
    },
    country: {
      type: String,
      required: false,
      default: null
    },
    lat: {
      type: Number,
      required: false,
      default: null
    },
    lng: {
      type: Number,
      required: false,
      default: null
    },
    isValidState: {
      type: Boolean,
      required: false,
      default: this.nav
    },
    setCityAndCountry: {
      type: Function,
      required: true
    }
  },
  mixins: [ defaultMixin ],
  data: function () {
    return {
      allowGeocode: false,
      showLocations: false,
      totalKeyDown: 0,
      location: '',
      locations: []
    }
  },
  watch: {
    location: _.debounce(function () {
      if (this.allowGeocode) {
        this.setCityAndCountry(null, null, null, null)
        this.totalKeyDown = 0
        this.geocode(this.location)
      }
      this.allowGeocode = false
    }, 500),
    city: function () {
      this.buildLocation()
    },
    country: function () {
      this.buildLocation()
    }
  },
  methods: {
    buildLocation: function () {
      if (this.city && this.country) {
        this.location = this.city + ', ' + this.$i18n.t('countries.' + this.country)
      }
    },
    resetLocations: function () {
      this.locations = []
    },
    setLocationAndCoordinates: function (location) {
      this.location = ''
      if (location.city !== null) {
        this.location = location.city
      }
      if (location.country !== null) {
        this.location = this.location + ', ' + this.$i18n.t('countries.' + location.country)
      }
      this.setCityAndCountry(location.city, location.country, Number(location.lat), Number(location.lng))
    },
    setDataFromStore: function () {
      this.setLocationAndCoordinates({
        city: this.$store.state.city,
        country: this.$store.state.country,
        lat: this.$store.state.lat,
        lng: this.$store.state.lng
      })
    },
    geocode: function (location) {
      const self = this
      this.resetLocations()

      geocodeService.geocode(location)
        .then((results) => {
          if (results && results.length > 0) {
            results.forEach(function (result) {
              self.locations.push(result)
            })
          }
        })
    },
    keyDownAutoComplete: function (e) {
      this.allowGeocode = true
      this.showLocations = true
      if (e.keyCode === 38 || e.keyCode === 40) {
        if (e.keyCode === 38) {
          this.totalKeyDown -= 1
        }
        if (e.keyCode === 40) {
          this.totalKeyDown += 1
        }
        if (this.totalKeyDown < 1) {
          this.totalKeyDown = 1
        }
        if (this.totalKeyDown > this.locations.length) {
          this.totalKeyDown = this.locations.length
        }
        if (this.locations.length > 0) {
          this.location = this.locations[this.totalKeyDown - 1].name
        }
      }
      if (e.keyCode === 13 && this.totalKeyDown > 0) {
        this.setLocationAndCoordinates(this.locations[this.totalKeyDown - 1])
        this.showLocations = false
        this.resetLocations()
      }
    },
    blurAutoComplete: function (e) {
      const self = this
      setTimeout(function () {
        self.totalKeyDown = 0
        self.showLocations = false
        self.resetLocations()
      }, 250)
    }
  },
  created: function () {
    let self = this
    this.$root.$on('updateLocale', () => {
      self.buildLocation()
    })
    this.$root.$on('updateNavigationLocation', () => {
      self.setDataFromStore()
    })
  },
  mounted: function () {
    this.buildLocation()
  },
  beforeDestroy: function () {
    this.$root.$off('updateLocale')
    this.$root.$off('updateNavigationLocation')
  }
}
</script>

<style scoped>
  .form-control-sm {
    width: 200px;
  }

  .list-group-item {
    padding: 10px;
    cursor: pointer;
  }

  .list-group-item-nav {
    padding: 5px 8px;
    width: 200px;
    cursor: pointer;
  }

  .list-group-item-nav-mobile {
    padding: 5px 8px;
    width: 100%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/LocationPicker.vue